import store from '@/store';
import { SERVICE_STATUS_REFRAL } from '@/forms/constants/services';

export default (serviceName) => {
  const { services } = store.state.formData;
  const hasServiceName = Object.prototype.hasOwnProperty.call(services, serviceName);
  if (hasServiceName) {
    return services[serviceName].status;
  }
  return SERVICE_STATUS_REFRAL.unvalidated;
};
